export default __webpack_public_path__ + "static/media/wobblyabcicon.56341004.png";